import { createSlice } from "@reduxjs/toolkit";


const ProjectSlice = createSlice({
    name: "Project",
    initialState: {
        shopDetailID: "",
        editUserID : ""
    },
    reducers: {
        handleViewVendorListDetails: ( state,action) => {

            state.shopDetailID = action.payload
        },
        handleEditUserID : (state,action)=>{
            state.editUserID =action.payload
        }
    },
});

export const {
    handleViewVendorListDetails,
    handleEditUserID
} = ProjectSlice.actions;
export default ProjectSlice.reducer;
